import { get } from '@/api/base'

export const selectableTypeVolumes = async params => {
  const response = await get({
    path: `containers/selectable_type_volumes`,
    params,
  })
  return response.success ? response.data.type_volumes : []
}
